<section class="service-unavailable">
  <h1 class="service-unavailable__title">Service unavailable</h1>
  <p class="service-unavailable__message">
    Services are currently not responding.
  </p>
  <p class="service-unavailable__message">
    Contact your completion administrator or service desk to check status.
  </p>

  <div class="service-unavailable__actions">
    <a pButton severity="warn" routerLink="/dashboard">Try again</a>
  </div>
</section>

